<app-nav-menu></app-nav-menu>
<dx-load-panel [(visible)]="isLoadPanelVisible">
</dx-load-panel>
<main class="main">
  <div class="cms_main fadeInUp animated">
    <div class="cms_card">
      <div class="easeoutin">
        <ng-template #PROGRESS let-modal>

          <div class="modal-success ">
            <img class="sucesspopup" src="assets/img/icons8-error.gif" />

            <p class="textpopupsuccess"> In Progress!</p>
            <p class="innerhtmlofmodal"> Please Choose Another?</p>

          </div>


        </ng-template>
      </div>
      <!--<div class="row-card">-->
        <div class="row">
          <!-- //20-jan-24 -->
          <div class="col-md-8" style="display: flex; flex-direction: column;">
            <div class="cms_card-heading">Request List</div>
            <div style="margin-top: 5px; color: red;" id="requestListError"></div>
          </div>
          <!-- <div class="col-md-2">
            <ng-select [items]="requestTypeList$ | async"
                       bindLabel="requestTypeName" bindValue="requestTypeId"
                       [searchable]="true"
                       [ngModelOptions]="{standalone: true}"
                       placeholder="Add New Re"
                       [(ngModel)]="requestTypeId"
                       (change)="OnRequestTypeChange(requestTypeId)"
                       >
            </ng-select>
          </div> -->
          <div class="col-md-4 position-req-new">
            
            <!-- [(ngModel)]="obj.booking.requestTypeId"
            
           [ngModelOptions]="{standalone: true}"-->
            <!--<div class="headNewOfflineSlect">
              <ng-select [items]="requestTypeList$ | async" bindLabel="requestTypeName" bindValue="requestTypeId"
                [searchable]="true" id="selectHeadOfMain" (change)="OnRequestTypeChange($event.requestTypeId)" 
                class="OfflineRequestListClass newOfflineClassHeader offline-main-class" placeholder="Select Request Type"
               >
              </ng-select>

              <label class="head-of-main-select" style="color: var(--first-color-second);" id="selectheadofmainLabel">Add New Request</label>
            </div>-->
  
            <!-- <br />
            <a class="card-icon" (click)="AddNewRequest()">
              <i class="uil uil-file-plus-alt card_custom-icon"></i>Add New
            </a> -->
            <!--<button class="Add-new-request-btn" ><i class="uil uil-plus-circle accor_icon"></i> Add New </button>-->
  
          </div>
        </div>
      <div class="row">

        <div class="devextr">


          <!--</div>-->

          <dx-data-grid #dataGridRequestList [dataSource]="requestList"
                        [showBorders]="true"
                        [showRowLines]="true"
                        [allowColumnResizing]="true"
                        (onCellPrepared)="onCellPrepared($event)"
                        (onContentReady)="contentReady($event)">

            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxi-column [visible]="false" alignment="center" caption="Request Type Id" dataField="requestType" dataType="string"></dxi-column>
            <dxi-column [width]="200" caption="Request Type" dataField="requestTypeName" dataType="string"></dxi-column>
            <dxi-column alignment="center" caption="Booking date" dataField="creationDate" dataType="Date" format="dd-MM-yyyy"></dxi-column>
            <dxi-column [visible]="false" alignment="center" caption="Booking Id" dataField="offlineBookingId"></dxi-column>
            <dxi-column alignment="center" caption="Booking Id" dataField="bookingAgencyId"></dxi-column>
            <dxi-column alignment="center" caption="Supplier" dataField="bookingSource" dataType="string"></dxi-column>
            <dxi-column alignment="center" caption="Pnr" dataField="pnr" dataType="string"></dxi-column>
            <dxi-column alignment="center" caption="Ticket No" dataField="tktNo" dataType="string"></dxi-column>
            <dxi-column alignment="center" caption="Trip" dataField="sector" dataType="string"></dxi-column>
            <dxi-column [visible]="false" alignment="center" dataField="agencyId" dataType="string"></dxi-column>
            <!--<dxi-column alignment="center" caption="Type" dataField="type" dataType="string"></dxi-column>-->
            <dxi-column alignment="center" caption="Passenger Name" dataField="passName" dataType="string"></dxi-column>
            <dxi-column [visible]="false" alignment="center" dataField="onlineBookingId" dataType="number"></dxi-column>
            <!--<dxi-column [allowFiltering]="true" alignmnet="center" caption="No of Pass" dataField="noOfPass" dataType="number"></dxi-column>-->
            <dxi-column [allowFiltering]="true" alignment="center" caption="Travel date" dataField="travelDate" dataType="Date" format="dd-MM-yyyy"></dxi-column>
            <dxi-column [allowFiltering]="true" alignment="center" caption="Status" dataField="status" dataType="string"></dxi-column>
            <dxi-column caption="Action" type="buttons" [width]="60">
              <dxi-button hint="Edit"
                          icon="edit"
                          [onClick]="onClickEditRequest"></dxi-button>
            </dxi-column>

            <dxo-search-panel [visible]="true"></dxo-search-panel>
            <dxo-paging [pageSize]="10"></dxo-paging>
            <dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[10, 25, 50, 100]"></dxo-pager>



          </dx-data-grid>

        </div>
      </div>
    </div>
  </div>
  <ng-template #confirmationModal let-modal>

    <div class="ticketConfirmationModelMain">
      <i class="fas fa-times ticketConfirmationPopupClose" aria-hidden="true" (click)="modal.close()"></i>
      <div class="ticketConfirmationModelInner">
        <div style="text-align: center; font-style: italic; font-size: 18px;margin-bottom: 25px;">
          Do You Want to Issue Ticket Online or Offline?
        </div>
        <div style="display: flex; justify-content: center; width: 100%;">
          <button class="onlineTicketIssue_btn" id="onlineTicketIssue_btn"
                  (click)="IssueTicketRequestOnline()">
            Issue Online
          </button>
          <button class="offlineTicketIssue_btn" id="offlineTicketIssue_btn" style="margin-left: 30px;"
                  (click)="IssueTicketRequestOffline()">
            Issue Offline
          </button>
        </div>
      </div>
    </div>
  </ng-template>
</main>
